import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/* ============================================================
   ScrollToTop
   Remonte en haut de page à chaque changement de route.
   React Router ne réinitialise pas le scroll par défaut.
   Exception : ouverture/fermeture de la route-modale /settings,
   l'écran d'arrière-plan garde sa position de scroll.
   ============================================================ */
function ScrollToTop() {
  const { pathname } = useLocation()
  const prevPathRef = useRef(pathname)

  useEffect(() => {
    const prevPath = prevPathRef.current
    prevPathRef.current = pathname
    if (prevPath.startsWith('/settings') || pathname.startsWith('/settings')) return
    // Navigation entre sections de la vitrine /design/:section : la position
    // de scroll est conservée (la nav latérale est sticky).
    if (prevPath.startsWith('/design') && pathname.startsWith('/design')) return
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
